import * as types from '../constants/ActionTypes';

export function updateField(name, value) {
  return {
    type: types.UPDATE_FIELD_VALUE,
    field: {
      name: name,
      value: value
    }
  };
}

export function updateCustomField(name, value) {
  return {
    type: types.UPDATE_CUSTOM_FIELD_VALUE,
    field: {
      name: name,
      value: value
    }
  };
}

export function setNewState(newState) {
  return {
    type: types.SET_NEW_STATE,
    newState: newState
  };
}
